import React from 'react'
import { Link } from 'react-router-dom'
import { prettyAmount } from '../../utils/amount'
import {basicMonthlyAmount,advancedMonthlyAmount,basicYearlyAmount,advancedYearlyAmount,
  basicWeekAmount,advancedWeekAmount} from '../../utils/publicPlanPrices';

const showApiAddonPlan =
  process.env.REACT_APP_SHOW_API_ADDON_PLAN === '1' || process.env.NODE_ENV !== 'production';

const basicYearlyListAmount = basicMonthlyAmount * 12;
const advancedYearlyListAmount = advancedMonthlyAmount * 12;

const PricingPlans = () => (
  <div className="bodySec storySec">
    <div className="container">
      <h2 className="text-left">
        <span>Pricing Plans</span>
      </h2>
      <div className="row">
        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4">
          <div className="priceBox">
            <div className="priceBox--header">
              <h2>
                <span>Basic</span>
              </h2>
              <p>Save with Yearly Subscription</p>
            </div>
            <div className="priceBox--amount priceBox--recurring">
              <ul>
                <li>
                  <h6>${prettyAmount(basicMonthlyAmount, 0)}</h6>
                  <p>per month</p>
                </li>
                <li>
                  <i>OR</i>
                </li>
                <li>
                  <h6>
                    <span className="priceBox-del">${prettyAmount(basicYearlyListAmount, 0)}</span>
                    <span className="priceBox-off" data-off={`Save $${basicYearlyListAmount - basicYearlyAmount}`}>${prettyAmount(basicYearlyAmount, 0)}</span>
                  </h6>
                  <p>Per Year</p>
                </li>
              </ul>
            </div>
	            <div className="priceBox--content">
	              <ul>
	                <li>7-day free trial on monthly plans</li>
	                <li>Predictions for 250 stocks</li>
	                <li>Daily, Two-Day, and Weekly horizons</li>
	                <li>Trading Strategies + Backtesting (Basic horizons)</li>
	                <li>Market Analysis briefs (Subject + Sentiment)</li>
	                <li>Data Search gain/loss columns + CSV export</li>
	              </ul>
	            </div>
              <p className="priceBoxTrialTerms">Monthly: 7 days free, then ${basicMonthlyAmount}/month until canceled.
                Payment method required. Cancel in Orders before the trial ends to avoid the subscription charge.
                Annual: ${prettyAmount(basicYearlyAmount,0)} charged upfront; renews yearly. No annual trial.</p>
            <div className="priceBox--footer">
              <Link to="/cabinet/order/13">
                Subscribe Monthly
              </Link>
              <Link to="/cabinet/order/2">
                Subscribe Yearly
              </Link>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4">
          <div className="priceBox">
            <div className="priceBox--header">
              <h2>
                <span>Advanced</span>
              </h2>
              <p>Save with Yearly Subscription</p>
            </div>
            <div className="priceBox--amount priceBox--recurring">
              <ul>
                <li>
                  <h6>${prettyAmount(advancedMonthlyAmount, 0)}</h6>
                  <p>per month</p>
                </li>
                <li>
                  <i>OR</i>
                </li>
                <li>
                  <h6>
                    <span className="priceBox-del">${prettyAmount(advancedYearlyListAmount, 0)}</span>
                    <span className="priceBox-off" data-off={`Save $${advancedYearlyListAmount - advancedYearlyAmount}`}>${prettyAmount(advancedYearlyAmount, 0)}</span>
                  </h6>
                  <p>Per Year</p>
                </li>
              </ul>
            </div>
	            <div className="priceBox--content">
	              <ul>
	                <li>7-day free trial on monthly plans</li>
	                <li>Predictions for 250 stocks</li>
	                <li>All horizons: 1D → 1Y</li>
	                <li>Trading Strategies + Backtesting (all horizons)</li>
	                <li>Market Analysis briefs (Subject + Sentiment)</li>
	                <li>Data Search gain/loss columns + CSV export</li>
	                <li>Broker Portfolio overlay (read-only)</li>
	                <li>Daily strategy action email + CSV export</li>
	              </ul>
	            </div>
              <p className="priceBoxTrialTerms">Monthly: 7 days free, then ${advancedMonthlyAmount}/month until canceled.
                Payment method required. Cancel in Orders before the trial ends to avoid the subscription charge.
                Annual: ${prettyAmount(advancedYearlyAmount,0)} charged upfront; renews yearly. No annual trial.</p>
            <div className="priceBox--footer">
              <Link to="/cabinet/order/14">
                Subscribe Monthly
              </Link>
              <Link to="/cabinet/order/4">
                Subscribe Yearly
              </Link>
            </div>
          </div>
        </div>
        {/*<div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">*/}
        {/*  <div className="entPriceBg">*/}
        {/*    <h2>*/}
        {/*      <span>enterprise</span>*/}
        {/*    </h2>*/}
        {/*    <ul>*/}
        {/*      <li>Custom time series data for training</li>*/}
        {/*      <li>Custom model adjustments</li>*/}
        {/*      <li>Advanced Deep Learning AI Models</li>*/}
        {/*      <li>API access to our Deep Learning AI Models</li>*/}
        {/*    </ul>*/}
        {/*    <div className="entMoreInfo">*/}
        {/*      <p>*/}
        {/*        Contact us at <a href="mailto://info@deeptrading.ai">info@deeptrading.ai</a> for pricing details.*/}
        {/*      </p>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</div>*/}
        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4">
          <div className="priceBox">
            <div className="priceBox--header">
              <h2>
                <span>One-Week Pass</span>
              </h2>
              <p>Single one-week purchase</p>
              <p className="priceBoxMicrocopy">One-time purchase. Not a subscription. No auto-renew.</p>
            </div>
            <div className="priceBox--amount">
              <ul>
                <li>
                  <h6>${prettyAmount(basicWeekAmount, 0)}</h6>
                  <p>Basic</p>
                </li>
                <li>
                  <i>OR</i>
                </li>
                <li>
                  <h6>${prettyAmount(advancedWeekAmount, 0)}</h6>
                  <p>Advanced</p>
                </li>
              </ul>
            </div>
            <div className="priceBox--content"></div>
            <div className="priceBox--footer">
              <Link to="/cabinet/order/5">
                Purchase Basic
              </Link>
              <Link to="/cabinet/order/6">
                Purchase Advanced
              </Link>
            </div>
          </div>
        </div>
        {showApiAddonPlan && (
          <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4">
            <div className="priceBox">
              <div className="priceBox--header">
                <h2>
                  <span>API Add-on</span>
                </h2>
                <p>Per-user API key + credit-based access</p>
              </div>
              <div className="priceBox--amount">
                <ul>
                  <li>
                    <h6>${prettyAmount(5, 0)}</h6>
                    <p>10 credits pack</p>
                  </li>
                  <li>
                    <i>OR</i>
                  </li>
                  <li>
                    <h6>${prettyAmount(20, 0)}</h6>
                    <p>40 credits pack</p>
                  </li>
                </ul>
              </div>
              <div className="priceBox--content">
                <ul>
                  <li>Rest API</li>
                  <li>Secure per-user API Key</li>
                  <li>Includes Strategy Backtest endpoint</li>
                  <li>Credit cost scales by backtest window</li>
                </ul>
              </div>
              <div className="priceBox--footer">
                <Link to="/cabinet/order/15?qty=1">
                  Buy $5 Pack
                </Link>
                <Link to="/cabinet/order/15?qty=4">
                  Buy $20 Pack
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="row">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div className="moreInfo">
            <p>
              Questions? Email us at <a href="mailto://info@deeptrading.ai">info@deeptrading.ai</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default PricingPlans;
